export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7650.e47725f7.jpg";